import { render } from "./ExamManage.vue?vue&type=template&id=5be5ec08&scoped=true"
import script from "./ExamManage.vue?vue&type=script&lang=ts"
export * from "./ExamManage.vue?vue&type=script&lang=ts"

import "./ExamManage.vue?vue&type=style&index=0&id=5be5ec08&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5be5ec08"

export default script